"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apartmentApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var apartmentApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: '/v1/admin/apartment',
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: '/v1/admin/apartment',
      data: data,
      method: 'post'
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/v1/admin/apartment/".concat(id, "/update"),
      method: 'post',
      data: data
    });
  },
  delete: function _delete(id) {
    return (0, _request.default)({
      url: "/v1/admin/apartment/".concat(id),
      method: 'delete'
    });
  }
};
exports.apartmentApi = apartmentApi;